import { useEffect, useState } from 'react';

import { getSession, subscribeSession } from '../api/session-store';
import type { MeResponse } from '../api/types';

/** Live view of the in-memory session snapshot (see api/session-store.ts). */
export function useSession(): { me: MeResponse | null } {
  const [me, setMe] = useState<MeResponse | null>(getSession().me);

  useEffect(() => subscribeSession(() => setMe(getSession().me)), []);

  return { me };
}
